export const en = {
    'empty-header': 'No negative keywords selected',
    'empty-text': 'Here you will see a list of negative keywords that you can add to your ad group',
    'remove-action': 'Clear the list',
    title: 'Negative keywords'
};
